import { Box, Button, Checkbox, debounce, FormControlLabel, Grid, Paper, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { RainfallDropdown } from "../components/dropdowns/rainfall/RainfallDropdown";
import { SoilTypeDropdown } from "../components/dropdowns/soil-type/SoilTypeDropDown";
import GenericSearchBar from "../components/GenericSearchBar";
import TrialControl from "../components/trial/TrialControl";
import { checkboxFilterModels, } from "../models/checkBoxFilterModel";
const Item = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
}));
const HomePage = () => {
    var _a;
    const location = useLocation();
    const [searchTerm, setSearchTerm] = useState("");
    const [rainfallCategory, setRainfallCategory] = useState("");
    const [soilTypeCategory, setSoilTypeCategory] = useState("");
    //this is bubbled up from the trial control component
    const [speciesInTrials, setSpeciesInTrials] = useState([]);
    //called after the trials are loaded in the trial control component
    const updateSpeciesInTrials = (species) => {
        setSpeciesInTrials(species);
    };
    const [filterModels, setFilterModels] = useState(checkboxFilterModels);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const site = params.get("site");
        if (site) {
            setSearchTerm(site);
        }
    }, [location.search]);
    //=================================================================================
    //                      Handle Filter Changes
    //=================================================================================
    const handleCheckBoxFilterChange = (event) => {
        const filterName = event.target.name;
        const isChecked = event.target.checked;
        const updatedFilters = filterModels.map((filter) => {
            if (filter.name === filterName) {
                filter.checked = isChecked;
                filter.value = searchTerm;
            }
            return filter;
        });
        setFilterModels(updatedFilters);
    };
    //=================================================================================
    //                      Handle Search Changes
    //=================================================================================
    function handleSearchChange(event) {
        var _a;
        setSearchTerm((_a = event.target.value) !== null && _a !== void 0 ? _a : '');
    }
    useEffect(() => {
        const updateFilters = () => {
            setFilterModels(prev => prev.map(filter => {
                //exclude rainfall and soil type
                if (filter.name !== "annualRainfall" && filter.name !== "soilTypeName") {
                    if (filter.checked) {
                        filter.value = searchTerm;
                    }
                    else {
                        filter.value = "";
                    }
                }
                return filter;
            }));
        };
        const handle = debounce(updateFilters, 500);
        handle();
        return () => {
            handle.clear();
        };
    }, [searchTerm]);
    //=================================================================================
    //                      Handle Rainfall Changes
    //=================================================================================
    function handleRainfallChange(id, range) {
        setRainfallCategory(id.toString());
        const filterName = "annualRainfall";
        let isChecked = true;
        if (id === null || id === undefined || id === "") {
            id = "";
            isChecked = false;
        }
        const updatedFilters = filterModels.map((filter) => {
            if (filter.name === filterName) {
                filter.checked = isChecked;
                filter.value = `${range[0]}<->${range[1]}`;
            }
            return filter;
        });
        setFilterModels(updatedFilters);
    }
    //=================================================================================
    //                      Handle Soil Type Changes
    //=================================================================================
    function handleSoilTypeChange(id, range) {
        let isChecked = true;
        if (id === null || id === undefined || id === "") {
            id = "";
            isChecked = false;
        }
        setSoilTypeCategory(id.toString());
        const filterName = "soilTypeName";
        const updatedFilters = filterModels.map((filter) => {
            if (filter.name === filterName) {
                filter.checked = isChecked;
                filter.value = `${range[0]}`;
            }
            return filter;
        });
        setFilterModels(updatedFilters);
    }
    //=======================================================================================
    //                            Reset Filters to default
    //=======================================================================================
    const handleResetFilters = () => {
        const updatedFilters = filterModels.map((filter) => {
            if (filter.name === "name") {
                filter.checked = true;
                filter.value = "";
            }
            else {
                filter.checked = false;
                filter.value = "";
            }
            return filter;
        });
        setFilterModels(updatedFilters);
        setSearchTerm("");
        setRainfallCategory("");
        setSoilTypeCategory("");
    };
    let componentWidth = window.innerWidth;
    //on window resize, update the width
    window.onresize = () => {
        const newWidth = window.innerWidth;
        if (newWidth !== componentWidth) {
            componentWidth = newWidth;
        }
    };
    return (React.createElement(Stack, { id: "home-content", sx: { flexGrow: 1, height: 'calc(100vh - 70px - (10px * 2))' }, spacing: 1, padding: '10px' },
        React.createElement(Box, { sx: { textAlign: "center" } },
            React.createElement(Typography, { variant: "body1", sx: {
                    // textAlign: isMobile ? "left" : "center",
                    // display: isMobile ? "none" : "block",
                    textAlign: {
                        xs: "left",
                        sm: "center"
                    },
                    // i think we can show this for mobile
                    // display: {
                    //   xs: "none",
                    //   sm: "block"
                    // },
                } },
                "This tool allows you to ",
                React.createElement("span", { className: "text-bold" }, "assess"),
                " ",
                "and ",
                React.createElement("span", { className: "text-bold" }, "compare"),
                " the performance of more than 100 pasture varieties across the key pasture species for the red meat industry:",
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("span", null,
                    React.createElement("span", null, 
                    //csv of species in trials and replace last comma with and
                    (_a = speciesInTrials.join(", ").replace(/,([^,]*)$/, " and$1")) !== null && _a !== void 0 ? _a : "")),
                React.createElement("br", null),
                React.createElement("br", null),
                "For more information about the Pasture Trial Network (PTN), please visit our ",
                React.createElement("a", { href: "https://www.pasturetrials.com.au/" }, "website"),
                ".")),
        React.createElement("div", { className: "searchFilters" },
            React.createElement(Grid, null,
                React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 6 },
                    React.createElement(Typography, { variant: "h5", sx: {
                            textAlign: "left",
                            marginBottom: "20px",
                            // display: isMobile ? "none" : "block",
                            display: {
                                xs: "none",
                                sm: "block"
                            }
                        } }, "Search By")),
                React.createElement(Stack, { spacing: { xs: 1, sm: 1 }, direction: "row", useFlexGap: true, sx: { flexWrap: "wrap" }, width: "100%" },
                    React.createElement(Item, { sx: {
                            // width: isMobile ? "100%" : "auto",
                            // marginLeft: isMobile ? "5px" : "0px"
                            width: {
                                xs: "100%",
                                sm: "auto"
                            },
                            marginLeft: {
                                xs: "5px",
                                sm: "0px"
                            }
                        } },
                        React.createElement(Box, { sx: {
                                // display: isMobile ? "none" : "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                marginBottom: "5px",
                                justifyContent: "top",
                                // marginLeft: isMobile ? "0px" : "0px",
                                display: {
                                    xs: "none",
                                    sm: "flex"
                                },
                                marginLeft: {
                                    xs: "0px",
                                    sm: "0px"
                                }
                            } },
                            filterModels.map((filter) => {
                                var _a;
                                //exclude rainfall and soil type
                                return filter.name !== "annualRainfall" &&
                                    filter.name !== "soilTypeName" && (React.createElement(Box, { key: filter.name },
                                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: filter.checked, onChange: handleCheckBoxFilterChange, name: filter.name, color: "primary", disabled: filter.name === "name" ? true : false }), label: (_a = filter.displayName) !== null && _a !== void 0 ? _a : filter.name })));
                            }),
                            React.createElement(Box, null,
                                React.createElement(Button, { variant: "outlined", color: "primary", onClick: handleResetFilters }, "Reset"))),
                        React.createElement(Box, { sx: {
                                // width: isMobile ? componentWidth - 75 : "auto"
                                width: "100%"
                            } },
                            React.createElement(GenericSearchBar, { searchQuery: searchTerm, onSearchChange: handleSearchChange, placeholder: "Species, site, year, region search ...." }))),
                    React.createElement(Item, { sx: {
                            // display: isMobile ? "none" : "block",
                            display: {
                                xs: "none",
                                sm: "block"
                            },
                            paddingTop: "28px",
                        } },
                        React.createElement(RainfallDropdown, { onChange: handleRainfallChange, value: rainfallCategory })),
                    React.createElement(Item, { sx: {
                            // display: isMobile ? "none" : "block",
                            display: {
                                xs: "none",
                                sm: "block"
                            },
                            paddingTop: "28px"
                        } },
                        React.createElement(SoilTypeDropdown, { onChange: handleSoilTypeChange, value: soilTypeCategory }))))),
        React.createElement(TrialControl, { filterModels: filterModels, onRowClick: () => {
                handleResetFilters();
            }, 
            // layoutType={isMobile ? "list" : "grid"}
            layoutType: "grid", onTrialsLoaded: updateSpeciesInTrials })));
};
export default HomePage;
